import ReadFirstPdf from "../assets/files/keys/1_read_first.pdf";
import ListOfKeysPdf from "../assets/files/keys/2_list.pdf";
import BeeGeneraPdf from "../assets/files/keys/3_bee_genera.pdf";
import AgapostemonPdf from "../assets/files/keys/agapostemon_of_the_tallgrass.pdf";
import AndrenaPdf from "../assets/files/keys/andrena_subgenera_of_the_tallgrass.pdf";
import AnthidiellumPdf from "../assets/files/keys/anthidiellum_of_the_tallgrass.pdf";
import AnthidiumPdf from "../assets/files/keys/anthidium_of_the_tallgrass.pdf";
import AnthophoraPdf from "../assets/files/keys/anthophora_of_the_tallgrass.pdf";
import AnthophorulaPdf from "../assets/files/keys/anthophorula_of_the_tgp.pdf";
import AugochlorellaPdf from "../assets/files/keys/augochlorella_of_the_tallgrass.pdf";
import AugochloropsisPdf from "../assets/files/keys/augochloropsis_of_the_tallgrass.pdf";
import BombusPdf from "../assets/files/keys/bombus_of_tgp.pdf";
import CalliopsisPdf from "../assets/files/keys/calliopsis_of _tgp.pdf";
import CeratinaPdf from "../assets/files/keys/ceratina_of_tgp.pdf";
import ColletesPdf from "../assets/files/keys/colletes_of_the_tallgrass.pdf";
import DiadasiaPdf from "../assets/files/keys/diadasia_of_the_tgp.pdf";
import DianthidiumPdf from "../assets/files/keys/dianthidium_of_tgp.pdf";
import DieunomiaPdf from "../assets/files/keys/dieunomia_of_the_tallgrass.pdf";
import EuceraPdf from "../assets/files/keys/eucera_of_tgp.pdf";
import HalictusPdf from "../assets/files/keys/halictus_of_tgp.pdf";
import HeriadesPdf from "../assets/files/keys/heriades_of_the_tgp.pdf";
import HoplitisPdf from "../assets/files/keys/hoplitis_of_tgp.pdf";
import HylaeusPdf from "../assets/files/keys/hylaeus_of _tgp.pdf";
import LasioglossumPdf from "../assets/files/keys/lasioglossum_of_tgp.pdf";
import LasioglossumSSPdf from "../assets/files/keys/lasioglossum_ss_of_tgp.pdf";
import MegaChilePdf from "../assets/files/keys/megachile_of_tgp.pdf";
import MellisodesPdf from "../assets/files/keys/melissodes_of_tgp.pdf";
import NomiaPdf from "../assets/files/keys/nomia_of_tgp.pdf";
import OsimaPdf from "../assets/files/keys/osmia_of_eastern.pdf";
import ProtandrenaPdf from "../assets/files/keys/protandrena_of_tgp.pdf";
import SvastaPdf from "../assets/files/keys/svastra_of_tgp.pdf";
import TetraloniellaPdf from "../assets/files/keys/tetraloniella_in_the_tallgrass.pdf";
import XenoglossaPdf from "../assets/files/keys/xenoglossa_of_tgp.pdf";
import XermolectaPdf from "../assets/files/keys/xeromelecta_of_the_tallgrass.pdf";

interface BeeKeyType {
  name: string;
  file: string;
}

export const BeeKeyList: BeeKeyType[] = [
  {
    name: "Introduction (Start Here)",
    file: ReadFirstPdf,
  },
  {
    name: "List of keys as of October 2, 2020",
    file: ListOfKeysPdf,
  },
  {
    name: "Bee genera of TGP and midwest",
    file: BeeGeneraPdf,
  },
  {
    name: "Agapostemon of the tallgrass prairie region and greater midwest",
    file: AgapostemonPdf,
  },
  {
    name: "Andrena subgenera of the tallgrass prairie region and greater midwest",
    file: AndrenaPdf,
  },
  {
    name: "Anthidiellum of the tallgrass prairie region and the greater midwest",
    file: AnthidiellumPdf,
  },
  {
    name: "Anthidium of the tallgrass prairie region and greater midwest",
    file: AnthidiumPdf,
  },
  {
    name: "Anthophora of the tallgrass prairie region and greater midwest",
    file: AnthophoraPdf,
  },
  {
    name: "Anthophorula of the TGP and midwest",
    file: AnthophorulaPdf,
  },
  {
    name: "Augochlorella of the tallgrass prairie region and greater midwest",
    file: AugochlorellaPdf,
  },
  {
    name: "Augochloropsis of the tallgrass prairie region and greater midwest",
    file: AugochloropsisPdf,
  },
  {
    name: "Bombus of TGP and midwest key",
    file: BombusPdf,
  },
  {
    name: "Calliopsis of TGP and midwest",
    file: CalliopsisPdf,
  },
  {
    name: "Ceratina of TGP and midwest",
    file: CeratinaPdf,
  },
  {
    name: "Colletes of the tallgrass prarie region and greater midwst",
    file: ColletesPdf,
  },
  {
    name: "Diadasia of the TGP and midwest",
    file: DiadasiaPdf,
  },
  {
    name: "Dianthidium of TGP and midwest",
    file: DianthidiumPdf,
  },
  {
    name: "Dieunomia of the tallgrass prairie region",
    file: DieunomiaPdf,
  },
  {
    name: "Eucera of TGP and midwest",
    file: EuceraPdf,
  },
  {
    name: "Halictus of TGP and midwest",
    file: HalictusPdf,
  },
  {
    name: "Heriades of the TGP and greater midwest",
    file: HeriadesPdf,
  },
  {
    name: "Hoplitis of TGP and midwest",
    file: HoplitisPdf,
  },
  {
    name: "Hylaeus of TGP and midwest",
    file: HylaeusPdf,
  },
  {
    name: "Lasioglossum non-metallic spp. of TGP",
    file: LasioglossumPdf,
  },
  {
    name: "Lasioglossum s.s. of TGP and midwest",
    file: LasioglossumSSPdf,
  },
  {
    name: "Megachile of TGP and midwest",
    file: MegaChilePdf,
  },
  {
    name: "Melissodes males of the TGP",
    file: MellisodesPdf,
  },
  {
    name: "Nomia s.s. of TGP and midwest",
    file: NomiaPdf,
  },
  {
    name: "Osmia of eastern NA females",
    file: OsimaPdf,
  },
  {
    name: "Protandrena s.s. of TGP and midwest",
    file: ProtandrenaPdf,
  },
  {
    name: "Svastra of the TGP and midwest",
    file: SvastaPdf,
  },
  {
    name: "Tetraloniella species in the tallgrass prairie region and the greater midwest",
    file: TetraloniellaPdf,
  },
  {
    name: "Xenoglossa of the TGP",
    file: XenoglossaPdf,
  },
  {
    name: "Xeromelecta of the tallgrass prairie region and greater Midwest",
    file: XermolectaPdf,
  },
];

export default BeeKeyList;
export type { BeeKeyType };
